export default __webpack_public_path__ + "static/media/dinner4.9c15cace.jpeg";